import { Component, inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";
import { NgClass } from "@angular/common";

import { TextComponent } from "../text/text.component";

export interface ToastProps {
  message: string;
  success: boolean;
}

@Component({
  selector: "app-toast",
  templateUrl: "./toast.component.html",
  styleUrls: ["./toast.component.scss"],
  imports: [NgClass, TextComponent],
  standalone: true,
})
export class ToastComponent {
  data = inject<ToastProps>(MAT_SNACK_BAR_DATA);
}
